import axios, { type AxiosError } from 'axios';

import { apiDefaultSettings } from 'src/app/services/settings';
import type { IError } from 'src/types/IError';

const API = axios.create(apiDefaultSettings);

const defaultApiTransformResponse = API.defaults.transformResponse
  ? Array.isArray(API.defaults.transformResponse)
    ? API.defaults.transformResponse
    : [API.defaults.transformResponse]
  : [];

API.interceptors.response.use(
  (response) => response,
  async (error: AxiosError<IError>) => {
    const response = error.response?.data;

    if (response) {
      console.error('API error message: ', response.message);

      throw new Error(response.message);
    }

    throw error;
  }
);

export { API, defaultApiTransformResponse };
